import {
  Component,
  ElementRef,
  Injectable,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import * as FileSaver from "file-saver";
import * as moment from "moment";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import * as XLSX from "xlsx";
declare var $: any;
const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";
@Injectable()
@Component({
    selector: "app-vehicle-grid",
    templateUrl: "./vehicle-grid.component.html",
    styleUrls: ["./vehicle-grid.component.scss"],
    standalone: false
})
export class VehicleGridComponent implements OnInit {
  @ViewChild("fileInput") fileInputRef!: ElementRef<HTMLInputElement>;
  startyear: Date;
  getStartYear: Date;
  bsConfig: Partial<BsDatepickerConfig>;
  FyearId: string;
  private _MasterService;
  vechileGridList: any[] = [];
  modelNameDropdown: any[] = [];
  selectedBulkImportYear: string = null;
  financialYears: string[] = []; // Populate with your year options
  file: any = null;
  fileInput: any = null;
  importJson: any = null;
  dataSource: any;
  displayedColumnsforTable: any;
  showSpinner: boolean = false;
  currentUser: any;
  Vehicle_Model_Name: any;
  displayedColumns: string[] = ["modelId", "modelName"];
  dataSourceViewDetails = new MatTableDataSource<any>();
  Vehicle_Category_Id: any;
  modelNameId: any;

  constructor(
    private route: ActivatedRoute,
    private lmsService: LmsService,
    private snackBar: MatSnackBar,
    private dataSharingService: DataSharingService,
    private masterService: MasterService
  ) {
    this.bsConfig = {
      dateInputFormat: "YYYY",
      minMode: "year",
      showWeekNumbers: false,
    };
  }

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Vehicle Grid");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.getVehicleGridModel();
    this.route.queryParams.subscribe((params) => {
      this.FyearId = params["fyear"];
      this.lmsService
        .Get_FinancialYear({ Id: this.FyearId })
        .subscribe((res: any) => {
          this.startyear = moment(res[0].fystart, "YYYY-MM-DD").toDate();
        });
    });
    this.LMS_GetVehicleModelMaster();
  }

  LMS_GetVehicleModelMaster() {
    this.showSpinner = true;
    this.lmsService.Get_Lms_VehicleModelMaster().subscribe((response: any) => {
      console.log(response);
      this.modelNameDropdown = response;
      // this.modelNameId = response.Vehicle_Category_Id;
      // console.log("id of vehicle id", this.modelNameId);
      // console.log("modelNameDropdown", this.modelNameDropdown);
    });
    this.showSpinner = false;
  }

  onYearChangeVehicleGridCallAPi(event: Date) {
    this.getStartYear = event;
    this.getVehicleGridModel();
  }

  onModelIdChangeVehicleGrid(event: any) {
    // console.log("Model name changed:", event);
    this.Vehicle_Model_Name = event;
    console.log("model name after change log", this.Vehicle_Model_Name);
    this.getVehicleGridModel();
  }

  getVehicleGridModel() {
    // this.getStartYear = event;
    var modelId = 0;
    if (
      this.Vehicle_Model_Name != "" &&
      this.Vehicle_Model_Name != null &&
      this.Vehicle_Model_Name != undefined
    ) {
      modelId = this.modelNameDropdown.filter(
        (x) => x.Vehicle_Model_Name == this.Vehicle_Model_Name
      )[0].Int_Id;
    }
    const selectedYearforVehicleGrid = moment(this.getStartYear).format("YYYY");
    const vehicleModelId = modelId;
    // console.log(
    //   "Selected Year for get api call outside call",
    //   selectedYearforVehicleGrid
    // );
    this.showSpinner = true;
    this.lmsService
      .Get_Vehicle_Model_Grid_List({
        year: selectedYearforVehicleGrid || 0,
        modelId: vehicleModelId || 0,
      })
      .subscribe((res: any) => {
        // if () {
        console.log("get data for vehicle grid", res);
        this.dataSourceViewDetails.data = res;
        this.updateDisplayedColumns(+selectedYearforVehicleGrid);
        // }
      });
    this.showSpinner = false;
  }

  updateDisplayedColumns(year: number): void {
    this.displayedColumns = ["modelId", "modelName"];
    for (let i = 0; i <= 15; i++) {
      this.displayedColumns.push(`Y${year - i}`);
    }
    // console.log("Displayed Column Dynamic", this.displayedColumns);
  }

  onYearChange(event: Date) {
    // console.log("enter in the on model change function");
    this.startyear = event;
    const selectedYear = moment(event).format("YYYY");

    this.lmsService
      .Get_Vehicle_Model_Grid({ year: selectedYear })
      .subscribe((result: any) => {
        if (result.length > 0) {
          this.dataSource = new MatTableDataSource(result);
          console.log("Data", this.dataSource);
          this.displayedColumnsforTable = ["modelId", "modelName", "price"];
          this.vechileGridList = JSON.parse(JSON.stringify(result));
          console.log("Vehicle grid list", this.vechileGridList);
        }
      });
  }

  onSaveVehicleGrid() {
    console.log("Save button clicked");

    console.log(
      "Current vehicle grid list before mapping:",
      this.vechileGridList
    );

    const Grid = this.dataSource.filteredData.map((row) => ({
      ModelId: row.modelId,
      Price: row.price,
    }));

    const selectedYear = moment(this.startyear).format("YYYY");

    this.lmsService
      .Save_Vehicle_Model_Grid({
        JSON: JSON.stringify(Grid),
        year: selectedYear,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        this.showSpinner = false;
        if (res[0].CODE >= 0) {
          console.log("saved data", res);
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });

          this.onYearChange(this.startyear);
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
        }
        $("#addVehicleGridModel").modal("hide");
      });
  }

  openAddVehicleGrid() {
    this.startyear = null;
    $("#addVehicleGridModel").modal("show");
    $("#addVehicleGridModel").css("z-index", "1050");
  }

  onCloseModal() {
    $("#addVehicleGridModel").modal("hide");
  }

  onCancelModal() {
    $("#addVehicleGridModel").modal("hide");
  }

  exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `VEHICLE GRID`,
      sheet: "VEHICLE GRID",
    });
  }
  exportVehicleMaster() {
    this.showSpinner = true;

    this.lmsService.Get_Lms_VehicleModelMaster().subscribe(
      (response: any) => {
        this.showSpinner = false;

        if (response && response.length > 0) {
          // Map to only the two columns
          const exportData = response.map((item: any) => ({
            ModelId: item.Int_Id,
            ModelName: item.Vehicle_Model_Name,
          }));

          // Convert to worksheet and export using XLSX
          import("xlsx").then((XLSX) => {
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = {
              Sheets: { VehicleModels: worksheet },
              SheetNames: ["VehicleModels"],
            };
            XLSX.writeFile(workbook, "Vehicle_Model_Master.xlsx");
          });
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data to export",
            ...this.configSuccess,
          });
        }
      },
      (error) => {
        this.showSpinner = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Error fetching vehicle models",
          ...this.configSuccess,
        });
      }
    );
  }
  ImportTemplate(excelFileName: string): void {
    // var json=[{Date:'',Rec_No:'',Rec_date:'',Loan_No:'',EMI_Amt:'',OD_Amt:'',Other_Amt:''}]
    var json = [["ModelId", "Price"]];
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(json);
    // console.log('worksheet',worksheet);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  openBulkImportModal() {
    // Optionally populate the year dropdown dynamically
    const currentYear = new Date().getFullYear();
    this.financialYears = [];
    for (let i = 0; i <= 15; i++) {
      this.financialYears.push((currentYear - i).toString());
    }

    this.selectedBulkImportYear = this.financialYears[0];
    $("#bulkImportModal").modal("show");
    $("#bulkImportModal").css("z-index", "1050");
  }

  onCloseBulkImportModal() {
    $("#bulkImportModal").modal("hide");
    this.file = null;
    this.importJson = null;
    this.selectedBulkImportYear = null;

    if (this.fileInput) (this.fileInput as HTMLInputElement).value = "";
  }

  bulkImportFileChange(event: any) {
    this.file = event.target.files[0];
    if (!this.file) return;

    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);
    fileReader.onload = (e) => {
      const arrayBuffer = fileReader.result as ArrayBuffer;
      const data = new Uint8Array(arrayBuffer);
      let arr: string[] = [];
      for (let i = 0; i < data.length; i++)
        arr[i] = String.fromCharCode(data[i]);
      const bstr = arr.join("");
      const workbook = XLSX.read(bstr, { type: "binary" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // Parse JSON
      this.importJson = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });
      this.importJson = this.importJson.map((row: any) => ({
        ModelId: row.ModelId ? String(row.ModelId).trim() : "",
        Price: row.Price ? String(row.Price).trim() : "",
      }));

      console.log("Parsed JSON from Excel:", this.importJson);

      // ✅ Validation
      const allowedColumns = ["ModelId", "Price"];
      if (this.importJson.length > 0) {
        const actualColumns = Object.keys(this.importJson[0]);

        const invalidColumns = actualColumns.filter(
          (c) => !allowedColumns.includes(c)
        );
        const missingColumns = allowedColumns.filter(
          (c) => !actualColumns.includes(c)
        );

        if (invalidColumns.length > 0 || missingColumns.length > 0) {
          alert(
            `Invalid Excel Format!\n\n` +
              (invalidColumns.length
                ? `Extra Columns: ${invalidColumns.join(", ")}\n`
                : "") +
              (missingColumns.length
                ? `Missing Columns: ${missingColumns.join(", ")}`
                : "")
          );
          this.importJson = []; // reset invalid data
          return;
        }
      }
    };
  }

  processBulkImport() {
    if (!this.selectedBulkImportYear || !this.importJson) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please select a year and file to import.",
        ...this.configSuccess,
      });
      return;
    }

    this.showSpinner = true;

    this.masterService
      .BulkImport_VehicleModel_Prices({
        JSON: JSON.stringify({ Search: this.importJson }),
        Year: this.selectedBulkImportYear,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe(
        (res: any) => {
          this.showSpinner = false;
          console.log("Bulk import response:", res);
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0]?.Msg || "Bulk import completed",
            ...this.configSuccess,
          });
          this.getVehicleGridModel();
          this.onCloseBulkImportModal();

          this.resetBulkImportFields();
        },
        (err) => {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Error during bulk import",
            ...this.configSuccess,
          });
        }
      );
    this.selectedBulkImportYear = null;
    this.importJson = null;
    this.fileInput = null;
    if (this.fileInput) (this.fileInput as HTMLInputElement).value = "";
  }

  resetBulkImportFields() {
    this.selectedBulkImportYear = "";
    this.importJson = null;

    // ✅ Force file input to clear both value & visible filename
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = "";
      this.fileInputRef.nativeElement.type = "text";
      this.fileInputRef.nativeElement.type = "file";
    }
  }
}
